// UI-only mock data and configuration for CondoUnitDetail.
// Backend developers will replace these constants with live data.

export const OVERVIEW_ITEMS = [
  { label: "Condo", value: "Oriental KH" },
  { label: "Parking Slots", value: "0" },
  { label: "Parking Slot Details", value: "Not assigned" },
  { label: "Maid Name", value: "Chi Kien Trinh" },
  { label: "Maid Number", value: "—" },
  { label: "Address", value: "Phnom Penh, Cambodia" },
  { label: "Unit", value: "1003 Oriental KH" },
  { label: "Rooms", value: "1" },
  { label: "Furnish Type", value: "Semi-furnished" },
  { label: "Occupants / Capacity", value: "1 / 1" },
  { label: "Unit Phone", value: "—" },
  { label: "Floor Area", value: "—" },
  { label: "Condo Company", value: "iCondo" },
  { label: "Unit Leader", value: "Chi Kien Trinh" },
  { label: "Allowance", value: "PHP 200.00" },
  { label: "Condo Sharing", value: "Not Shared" },
  { label: "In-Charge", value: "VT027 (Ken)" }
];

export const CONTRACTS = [
  {
    id: "latest",
    label: "Contract Start Date : 07/02/2025 (Latest)",
    fields: [
      // Rental column
      { label: "Rental Fee", value: "PHP 650.00", group: "rental" },
      { label: "Payment Term", value: "6 months", group: "rental" },
      { label: "Monthly Rent", value: "PHP 108.33", group: "rental" },
      { label: "Contract Start Date", value: "07/02/2025", group: "rental" },
      { label: "Contract End Date", value: "06/02/2026", group: "rental" },
      { label: "Termination Date", value: "—", group: "rental" },
      { label: "Active", value: "Yes", type: "chip", color: "success", group: "rental" },
      { label: "Remarks", value: "—", group: "rental" },

      // Security column
      { label: "Security Deposit", value: "PHP 750.00", group: "security" },
      { label: "Security Months", value: "1", group: "security" },
      { label: "Security Ref No", value: "—", group: "security" },
      { label: "Security Receipt Date", value: "—", group: "security" },
      { label: "Skip Security Deposit Alert", value: "No", group: "security" },
      { label: "Security Deposit Returned Amount", value: "PHP 0.00", group: "security" },
      { label: "Security Deposit Returned Date", value: "—", group: "security" },
      { label: "Security Deposit Expense", value: "—", group: "security" },

      // Advance column
      { label: "Advance Payment", value: "PHP 0.00", group: "advance" },
      { label: "Advance Months", value: "0", group: "advance" },
      { label: "Advance Credit", value: "PHP 0.00", group: "advance" },
      { label: "Advance Receipt Date", value: "—", group: "advance" },
      { label: "Broker Name", value: "—", group: "advance" },
      { label: "Broker Phone Number", value: "—", group: "advance" },
      { label: "Broker E-mail", value: "—", group: "advance" },
      { label: "Lessee", value: "JK", group: "advance" },
      { label: "Lessee Address", value: "PP", group: "advance" },

      // Lessor column
      { label: "Lessor", value: "Sarbouen Sivutha", group: "lessor" },
      { label: "Lessor Phone", value: "—", group: "lessor" },
      { label: "Lessor Bank Acct Name", value: "—", group: "lessor" },
      { label: "Lessor Bank Acct No", value: "—", group: "lessor" },
      { label: "Lessor Bank", value: "—", group: "lessor" },
      { label: "Lessor Bank Name", value: "—", group: "lessor" },
      { label: "Lessor Bank Address", value: "—", group: "lessor" },
      { label: "Bank Swift Code", value: "—", group: "lessor" }
    ]
  },
  {
    id: "previous",
    label: "Contract Start Date : 07/02/2024",
    fields: [
      // Rental column
      { label: "Rental Fee", value: "PHP 650.00", group: "rental" },
      { label: "Payment Term", value: "6 months", group: "rental" },
      { label: "Monthly Rent", value: "PHP 108.33", group: "rental" },
      { label: "Contract Start Date", value: "07/02/2024", group: "rental" },
      { label: "Contract End Date", value: "06/02/2025", group: "rental" },
      { label: "Termination Date", value: "—", group: "rental" },
      { label: "Active", value: "No", type: "chip", color: "error", group: "rental" },
      { label: "Remarks", value: "—", group: "rental" },

      // Security column
      { label: "Security Deposit", value: "PHP 750.00", group: "security" },
      { label: "Security Months", value: "1", group: "security" },
      { label: "Security Ref No", value: "—", group: "security" },
      { label: "Security Receipt Date", value: "—", group: "security" },
      { label: "Skip Security Deposit Alert", value: "No", group: "security" },
      { label: "Security Deposit Returned Amount", value: "PHP 0.00", group: "security" },
      { label: "Security Deposit Returned Date", value: "—", group: "security" },
      { label: "Security Deposit Expense", value: "—", group: "security" },

      // Advance column
      { label: "Advance Payment", value: "PHP 0.00", group: "advance" },
      { label: "Advance Months", value: "0", group: "advance" },
      { label: "Advance Credit", value: "PHP 0.00", group: "advance" },
      { label: "Advance Receipt Date", value: "—", group: "advance" },
      { label: "Broker Name", value: "—", group: "advance" },
      { label: "Broker Phone Number", value: "—", group: "advance" },
      { label: "Broker E-mail", value: "—", group: "advance" },

      // Lessor column
      { label: "Lessor", value: "Sarbouen Sivutha", group: "lessor" },
      { label: "Lessor Phone", value: "—", group: "lessor" },
      { label: "Lessor Bank Acct Name", value: "—", group: "lessor" },
      { label: "Lessor Bank Acct No", value: "—", group: "lessor" },
      { label: "Lessor Bank", value: "—", group: "lessor" },
      { label: "Lessor Bank Name", value: "—", group: "lessor" },
      { label: "Lessor Bank Address", value: "—", group: "lessor" },
      { label: "Bank Swift Code", value: "—", group: "lessor" },
      { label: "Lessee", value: "JK", group: "lessor" },
      { label: "Lessee Address", value: "PP", group: "lessor" }
    ]
  }
];

export const INVENTORY_ROWS = [
  {
    room: "Master Bedroom",
    item: "Bed",
    ownedBy: "Company",
    status: "In use",
    qty: 1,
    unitPrice: "PHP 15,000.00",
    total: "PHP 15,000.00",
    purchased: "01/10/2023",
    remarks: "Queen size"
  },
  {
    room: "Living Room",
    item: "Sofa",
    ownedBy: "Company",
    status: "In use",
    qty: 1,
    unitPrice: "PHP 12,000.00",
    total: "PHP 12,000.00",
    purchased: "05/10/2023",
    remarks: "3-seater"
  }
];

export const DETAIL_TABLES = [
  {
    id: "misc-expenses",
    title: "Active Misc Expenses",
    manageLabel: "Manage Misc Expense",
    columns: ["Type", "Amount", "Start Date", "Payable To", "In-Charge", "Remarks"]
  },
  {
    id: "utilities",
    title: "Active Utilities",
    manageLabel: "Manage Utilities",
    columns: [
      "Type",
      "Account Name",
      "Account No",
      "Amount",
      "Start Date",
      "Payable To",
      "In-Charge",
      "Remarks"
    ]
  },
  {
    id: "inventory",
    title: "Inventory",
    manageLabel: "Manage Inventory",
    columns: ["Room", "Item", "Owned By", "Status", "Qty", "Unit Price", "Total", "Remarks"]
  },
  {
    id: "attachments",
    title: "Attachments",
    manageLabel: "Manage Attachment",
    columns: ["File", "Date Created"]
  }
];

export const MISC_EXPENSE_ROWS = [
  {
    type: "Internet",
    amount: "PHP 0.00",
    startDate: "25/10/2023",
    payableTo: "Converge",
    inCharge: "",
    remarks: ""
  },
  {
    type: "Appliance",
    amount: "PHP 0.00",
    startDate: "16/10/2023",
    payableTo: "",
    inCharge: "",
    remarks: ""
  },
  {
    type: "Start Up Supplies",
    amount: "PHP 100,000.00",
    startDate: "06/10/2023",
    payableTo: "",
    inCharge: "",
    remarks: ""
  },
  {
    type: "Stay In Allowance",
    amount: "PHP 17,500.00",
    startDate: "01/10/2023",
    payableTo: "",
    inCharge: "",
    remarks: ""
  }
];

export const RENTAL_PAYMENT_ROWS = [
  {
    acctEntryDate: "01/10/2023",
    periodCovered: "01/10/2023 - 30/09/2024",
    receiptNo: "11228",
    paymentDate: "05/10/2023",
    rfNo: "11228",
    checkNo: "CHK-001",
    amount: "PHP 480,000.00",
    remarks: "Initial contract payment",
    status: "credit"
  },
  {
    acctEntryDate: "01/10/2024",
    periodCovered: "01/10/2024 - 30/11/2024",
    receiptNo: "11766",
    paymentDate: "27/09/2024",
    rfNo: "11766",
    checkNo: "CHK-002",
    amount: "PHP 80,000.00",
    remarks: "Extension payment",
    status: "debit"
  }
];

export const MISC_PAYMENT_ROWS = [
  {
    acctEntryDate: "01/08/2025",
    periodCovered: "01/08/2025 - 31/08/2025",
    paymentDate: "15/08/2025",
    expenseType: "Internet",
    amount: "PHP 4,800.00",
    rfNo: "M-2025-001",
    checkNo: "",
    payableTo: "Converge",
    condoCompany: "Caspo",
    condoSharing: "Not Shared",
    remarks: "Monthly bill"
  },
  {
    acctEntryDate: "01/07/2025",
    periodCovered: "01/07/2025 - 31/07/2025",
    paymentDate: "10/07/2025",
    expenseType: "Appliance",
    amount: "PHP 3,001.80",
    rfNo: "M-2025-002",
    checkNo: "",
    payableTo: "",
    condoCompany: "Caspo",
    condoSharing: "Not Shared",
    remarks: "Microwave amortization"
  }
];

export const UTILITY_PAYMENT_ROWS = [
  {
    acctEntryDate: "01/10/2024",
    periodCovered: "16/09/2024 - 15/10/2024",
    paymentDate: "29/10/2024",
    utilityType: "Electricity",
    amount: "PHP 6,546.06",
    rfNo: "U-2024-001",
    checkNo: "",
    payableTo: "Meralco",
    condoCompany: "Caspo",
    condoSharing: "Not Shared",
    remarks: ""
  },
  {
    acctEntryDate: "01/09/2024",
    periodCovered: "16/08/2024 - 15/09/2024",
    paymentDate: "04/10/2024",
    utilityType: "Electricity",
    amount: "PHP 10,179.69",
    rfNo: "U-2024-002",
    checkNo: "",
    payableTo: "Meralco",
    condoCompany: "Caspo",
    condoSharing: "Not Shared",
    remarks: ""
  }
];

export const MAINTENANCE_ROWS = [
  {
    date: "01/08/2024",
    description: "Aircon cleaning",
    inCharge: "Building Admin",
    total: "PHP 3,500.00",
    acctEntryDate: "05/08/2024"
  },
  {
    date: "15/09/2024",
    description: "Plumbing repair",
    inCharge: "Maintenance",
    total: "PHP 2,150.00",
    acctEntryDate: "18/09/2024"
  }
];

export const ALLOWANCE_ROWS = [
  {
    eid: "1244",
    fullName: "Trung Van Thanh Nguyen",
    condo: "Island Plaza Salcedo",
    condoUnit: "10-A Island Plaza",
    payment: "Oct 2024 Allowance",
    payableTo: "JK",
    remarks: "Stay-in allowance",
    amount: "PHP 17,500.00",
    condoCompany: "Caspo",
    condoSharing: "Not Shared"
  },
  {
    eid: "1323",
    fullName: "Huy Quoc Tran",
    condo: "Island Plaza Salcedo",
    condoUnit: "10-A Island Plaza",
    payment: "Nov 2024 Allowance",
    payableTo: "JK",
    remarks: "Stay-in allowance",
    amount: "PHP 17,500.00",
    condoCompany: "Caspo",
    condoSharing: "Not Shared"
  }
];

export const ATTACHMENT_ROWS = [
  {
    file: "28f-threeeen-microwave.pdf",
    dateCreated: "08/11/2023"
  }
];

export const UTILITIES_ROWS = [
  {
    type: "Electricity",
    accountName: "Meralco",
    accountNo: "0",
    amount: "PHP 0.00",
    startDate: "07/12/2023",
    payableTo: "Meralco",
    inCharge: "",
    remarks: ""
  }
];
